import { createApiCall2, MethodType, URI } from "../Api";
import { SubDepartmentListData } from "models/subdepartmentList";

export const fetchSubDepartmentList = (payload: SubDepartmentListData) => {
  return createApiCall2(MethodType.GET, URI.USERS.GETDEPARTMENTLIST, payload);
};
